/* RampReady - Voorlichtingsavonden & bijeenkomsten (live laag).
 * Custom zoekbare gemeente-combobox (on-brand, toetsenbord + ARIA) + regio-fallback
 * (gemeente -> veiligheidsregio -> provincie -> landelijk) + auto-refresh met LIVE-indicator.
 * Server-side baseline blijft staan als de API faalt. */
(function () {
  var LS_KEY = 'rr_gemeente';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function fmtDate(iso) { if (!iso) return ''; try { return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; } }
  function fmtUpd(iso) { try { return 'bijgewerkt ' + new Date(iso).toLocaleString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } }

  function itemHTML(it) {
    var meta = '';
    if (it.type === 'bijeenkomst') meta += 'Bijeenkomst &middot; ';
    meta += esc(it.source || it.gemeente || '');
    var d = it.startDate || it.published;
    if (d) meta += ' &middot; ' + esc(fmtDate(d));
    if (it.gemeente && it.source !== it.gemeente) meta += ' &middot; ' + esc(it.gemeente);
    var loc = '';
    if (it.location) loc = '<span class="news-events__loc">' + esc(it.location) + (it.time ? ' &middot; ' + esc(it.time) : '') + '</span>';
    var snip = it.snippet ? '<p class="news-events__snip">' + esc(it.snippet) + '</p>' : '';
    var cta = it.collection ? '<a class="news-events__cta" href="' + esc(it.collection.url) + '">Bekijk ' + esc(it.collection.title) + ' →</a>' : '';
    var thumb = it.image ? '<img class="news-events__thumb" src="' + esc(it.image) + '" alt="" width="64" height="64" loading="lazy" referrerpolicy="no-referrer" onerror="this.remove()">' : '';
    return '<li class="news-events__item">' + thumb + '<span class="news-events__src">' + meta + '</span>' +
      '<a class="news-events__title" href="' + esc(it.url) + '" target="_blank" rel="noopener nofollow">' + esc(it.title) + '</a>' +
      loc + snip + cta + '</li>';
  }
  function listHTML(items) { return (items || []).map(itemHTML).join(''); }
  function groupHTML(title, items) {
    if (!items || !items.length) return '';
    return '<li class="news-events__group"><p class="news-events__group-title">' + esc(title) + '</p>' +
      '<ul class="news-events__list" role="list">' + listHTML(items) + '</ul></li>';
  }

  function init(root) {
    var api = root.getAttribute('data-api-url');
    var gemeentesUrl = root.getAttribute('data-gemeentes-url');
    var max = parseInt(root.getAttribute('data-max'), 10) || 8;
    var refresh = parseInt(root.getAttribute('data-refresh'), 10) || 0;
    var list = root.querySelector('[data-events-list]');
    var note = root.querySelector('[data-events-note]');
    var liveEl = root.querySelector('[data-events-live]');
    var updatedEl = root.querySelector('[data-events-updated]');
    var controls = root.querySelector('[data-events-controls]');
    var combo = root.querySelector('[data-events-combo]');
    var input = root.querySelector('[data-events-gemeente-input]');
    var optionsEl = root.querySelector('[data-events-options]');
    var clearBtn = root.querySelector('[data-events-clear]');
    if (!api || !list) return;

    var gemeenten = [];      // [{naam, slug, provincie, vr}]
    var selectedSlug = '';
    var activeIdx = -1;
    var shown = [];          // huidige gefilterde opties

    function setNote(txt) { if (!note) return; if (txt) { note.textContent = txt; note.hidden = false; } else { note.hidden = true; } }
    function markLive(updated) { if (liveEl) { liveEl.hidden = false; liveEl.classList.add('is-live'); } if (updatedEl && updated) updatedEl.textContent = fmtUpd(updated); }

    /* ---------- Combobox ---------- */
    function openList() { if (optionsEl) { optionsEl.hidden = false; input.setAttribute('aria-expanded', 'true'); } }
    function closeList() { if (optionsEl) { optionsEl.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIdx = -1; } }

    function renderOptions(q) {
      if (!optionsEl) return;
      var query = (q || '').trim().toLowerCase();
      shown = gemeenten.filter(function (g) {
        return !query || g.naam.toLowerCase().indexOf(query) >= 0;
      }).slice(0, 60);
      if (!shown.length) {
        optionsEl.innerHTML = '<li class="news-events__option news-events__option--empty">Geen gemeente gevonden</li>';
        openList(); return;
      }
      optionsEl.innerHTML = shown.map(function (g, i) {
        var sel = g.slug === selectedSlug ? ' aria-selected="true"' : '';
        return '<li class="news-events__option" role="option" id="ne-opt-' + i + '" data-slug="' + esc(g.slug) + '" data-naam="' + esc(g.naam) + '"' + sel + '>' +
          '<span class="news-events__option-name">' + esc(g.naam) + '</span>' +
          '<span class="news-events__option-prov">' + esc(g.provincie || '') + '</span></li>';
      }).join('');
      activeIdx = -1;
      openList();
    }

    function setActive(idx) {
      var opts = optionsEl.querySelectorAll('.news-events__option');
      if (!opts.length) return;
      if (idx < 0) idx = opts.length - 1;
      if (idx >= opts.length) idx = 0;
      opts.forEach(function (o) { o.classList.remove('is-active'); });
      var el = opts[idx];
      if (el && el.dataset.slug !== undefined) {
        el.classList.add('is-active');
        input.setAttribute('aria-activedescendant', el.id);
        el.scrollIntoView({ block: 'nearest' });
        activeIdx = idx;
      }
    }

    function choose(slug, naam) {
      selectedSlug = slug || '';
      if (input) input.value = naam || '';
      try { if (slug) localStorage.setItem(LS_KEY, slug); else localStorage.removeItem(LS_KEY); } catch (e) {}
      if (clearBtn) clearBtn.hidden = !slug;
      closeList();
      load();
    }

    if (input && optionsEl) {
      input.addEventListener('focus', function () { renderOptions(input.value); });
      input.addEventListener('input', function () { selectedSlug = ''; if (clearBtn) clearBtn.hidden = true; renderOptions(input.value); });
      input.addEventListener('keydown', function (e) {
        if (optionsEl.hidden && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) { renderOptions(input.value); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
        else if (e.key === 'Enter') {
          if (activeIdx >= 0 && shown[activeIdx]) { e.preventDefault(); choose(shown[activeIdx].slug, shown[activeIdx].naam); }
        } else if (e.key === 'Escape') { closeList(); }
      });
      optionsEl.addEventListener('mousedown', function (e) {
        var li = e.target.closest('.news-events__option'); if (!li || li.dataset.slug === undefined) return;
        e.preventDefault(); choose(li.dataset.slug, li.dataset.naam);
      });
      document.addEventListener('click', function (e) { if (combo && !combo.contains(e.target)) closeList(); });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () { choose('', ''); });

    /* ---------- Data laden ---------- */
    if (gemeentesUrl && controls && optionsEl) {
      fetch(gemeentesUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          gemeenten = (d.gemeentes || []).map(function (g) { return { naam: g.naam, slug: g.slug, provincie: g.provincie, vr: g.vr }; });
          controls.hidden = false;
          var saved = '';
          try { saved = localStorage.getItem(LS_KEY) || ''; } catch (e) {}
          if (saved) {
            var hit = gemeenten.filter(function (g) { return g.slug === saved; })[0];
            if (hit) { selectedSlug = saved; if (input) input.value = hit.naam; if (clearBtn) clearBtn.hidden = false; }
          }
          load();
        })
        .catch(function () { load(); });
    } else {
      load();
    }

    function renderDefault(events) {
      var items = (events || []).slice(0, Math.max(max, 12));
      if (items.length) list.innerHTML = listHTML(items);
      setNote('');
    }

    function renderFiltered(data, gemeenteNaam) {
      var ev = data.events || {};
      var html = '';
      if (ev.exact && ev.exact.length) {
        setNote(ev.exact.length + ' bericht' + (ev.exact.length === 1 ? '' : 'en') + ' over voorbereiding in ' + gemeenteNaam + '.');
        html = listHTML(ev.exact);
      } else {
        setNote('Nog geen lokaal bericht gevonden in ' + gemeenteNaam + '. Hieronder uit de buurt:');
        html = groupHTML('In jouw veiligheidsregio', ev.regio) +
               groupHTML('In jouw provincie', ev.provincie) +
               groupHTML('Landelijk', ev.landelijk);
        if (!html) html = '<li class="news-events__item news-events__empty">Op dit moment geen aangekondigde berichten of bijeenkomsten. Kom binnenkort terug of stel alvast je noodpakket samen.</li>';
      }
      list.innerHTML = html;
    }

    function load() {
      var url = selectedSlug ? (api + (api.indexOf('?') >= 0 ? '&' : '?') + 'gemeente=' + encodeURIComponent(selectedSlug)) : api;
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          markLive(data.updated);
          if (selectedSlug && data.events && !Array.isArray(data.events)) {
            renderFiltered(data, (input && input.value) || 'jouw gemeente');
          } else {
            renderDefault(data.events);
          }
        })
        .catch(function () { /* baseline (server-side) blijft staan */ });
    }

    if (refresh > 0) setInterval(load, refresh * 1000);
  }

  document.querySelectorAll('[data-news-events]').forEach(init);
})();
